module.exports = __webpack_public_path__ + "img/sec2_img1_m.89fbaa52.png";